module.exports = function(app) {
	app.run(['Service', '$cookies', 'brandConfig', 'sessionData',
		function(Service, $cookies, brandConfig, sessionData) {
			new Service({

				name: 'reasonCodes',
				group:'rbsmbl',
				url:'/rbsmbl/x-services/providerInfo/reasonCodes',

				fetch: function(payload) {
					var cookieValue = brandConfig.getSharedBrandCodeFromLeafUBK( sessionData.employerInfo.brandName );
					$cookies.put('umsBrand', cookieValue, { path: '/' });

					return this.get(payload).then(
						function(response) {
							$cookies.remove('umsBrand', { path: '/'});
							return response;
						}
					);
				}
			});
		}
	]);
};
